import { Injectable,Component } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class preStudentAddressInfo {
  PreStudentUGDetailsList:PreStudentUGDetailsList[];
      StudentOtherInfoID:number
      StudentID:number
      PreviousExamID:number
      PreQualifiedCourseID :number
      PreQualifiedBranchID :number
      PreExamUniversityID:number
      PreviousExamMonth:string
      PreviousExamYear:number
      PreviousExamPercentage:number
      PreviousExamSeatNo:number
      PreviousGrade:string
      EducationalStreamID:number
      EduStrmOtherInfo:string
      PreviousCollegeSchoolName :string
      PreviousExamName :string
      PreviousCategory:string
      Maxmarks :number
      Obtmarks :number
      StudentType :number
      CreatedLoginID:number
      UpdatedLoginID:number
      tenYear:number;
      Type:string;
      PreviousCGPA:number;
      UniversityName:string;
      PassAppType:string;
      SchoolUdise:string;
      SaralID:string;
}
export class preStudentAddressInfoEdu {
  PreStudentUGDetailsList:PreStudentUGDetailsList[];
      StudentOtherInfoID:number
      StudentID:number
      PreviousExamID:number
      PreQualifiedCourseID :number
      PreQualifiedBranchID :number
      PreExamUniversityID:number
      PreviousExamMonth:string
      PreviousExamYear:number
      PreviousExamPercentage:number
      PreviousExamSeatNo:number
      PreviousGrade:string
      EducationalStreamID:number
      EduStrmOtherInfo:string
      PreviousCollegeSchoolName :string
      PreviousExamName :string
      PreviousCategory:string
      Maxmarks :number
      Obtmarks :number
      StudentType :number
      CreatedLoginID:number
      UpdatedLoginID:number
      tenYear:number;
      Type:string;
      PreviousCGPA:number;
      UniversityName:string;
      PassAppType:string;
      SchoolUdise:string;
      SaralID:string;
}
export class UGMarkDetails{
  YearCode:string;
  YearTotalObtain:number;
  YearTotalMax:number;
  SpeciTotalObtain:number;
  SpeciTotalMax:number;
}
export class PreStudentUGDetailsList{
  YearCode1:string;
  YearCode:number;
  YearTotalObtain:number;
  YearTotalMax:number;
  SpeciTotalObtain:number;
  SpeciTotalMax:number;
  StudentID:number;
  AcademicInstanceID:number;
  CourseID:number;
  BranchID:number;
  CreatedLoginID:number;
  UpdatedLoginID:number;
  PreviousExamID:number;
}
export class EducationalStream {
  EducationalStreamID:number;
  EducationalStreamName:string;
  AddInfo:string;
}
export class EducationTypeData{
  PassAppType:string;
  EducationType:string;
}
let educationdata:EducationTypeData[]=[
  {
    PassAppType:"P",
    EducationType:"Pass"
  },
  {
    PassAppType:"A",
    EducationType:"Appear"
  }
]
let educationaldetails: preStudentAddressInfo[] = [
  {
    PreStudentUGDetailsList:[],
      StudentOtherInfoID: 0,
      StudentID:0,
      PreviousExamID:0,
      PreQualifiedCourseID :0,
      PreQualifiedBranchID :0,
      PreExamUniversityID:0,
      PreviousExamMonth:"",
      PreviousExamYear:0,
      PreviousExamPercentage:0,
      PreviousExamSeatNo:0,
      PreviousGrade:"",
      EducationalStreamID:0,
      EduStrmOtherInfo:"",
      PreviousCollegeSchoolName :"",
      PreviousExamName :"",
      PreviousCategory:"",
      Maxmarks :0,
      Obtmarks :0,
      StudentType :0,
      CreatedLoginID:0,
      UpdatedLoginID:0,
      tenYear:0,
      Type:"",
      PreviousCGPA:0,
      UniversityName:"",
      PassAppType:"",
      SchoolUdise:"",
      SaralID:"",

   
  }
];

let ugmarkdetails:UGMarkDetails[]=[{
  YearCode:"I",
  YearTotalObtain:0,
  YearTotalMax:0,
  SpeciTotalObtain:0,
  SpeciTotalMax:0
  },
  {
    YearCode:"II",
    YearTotalObtain:0,
    YearTotalMax:0,
    SpeciTotalObtain:0,
    SpeciTotalMax:0
    },
  {
    YearCode:"III",
    YearTotalObtain:0,
    YearTotalMax:0,
    SpeciTotalObtain:0,
    SpeciTotalMax:0
    },
    /* {
      YearCode:"IV",
      YearTotalObtain:0,
      YearTotalMax:0,
      SpeciTotalObtain:0,
      SpeciTotalMax:0
    } */
]
@Injectable( {  
  providedIn: 'root'  
})
@Component({
  providers: [DataAccessService]
})

export class EducationaldetailService {

  constructor(private dataService: DataAccessService) {
   
   }
  public save(data) {debugger
    this.dataService.setControllerName = '/PreStudentOtherInfo/';
    this.dataService.setMethodName = 'PostInsertPreStudentOtherInfo'; // setting method name from API controller.
    return this.dataService.add<preStudentAddressInfo[]>(data) 
  }
  public update(data) {
    this.dataService.setControllerName = '/PreStudentOtherInfo/';
    this.dataService.setMethodName = 'PostPreStudentOtherInfo'; // setting method name from API controller.
    return this.dataService.add<preStudentAddressInfo[]>(data)
  }
  public delete(data) {
    
    this.dataService.setControllerName = '/PreStudentOtherInfo/';
    this.dataService.setMethodName = 'PostDeletePreStudentOtherInfo?StudentOtherInfoID=' + data.StudentOtherInfoID + '';
    return this.dataService.add<preStudentAddressInfo[]>(data)
  }
  public GetContactinfo(StudentID) {
    this.dataService.setControllerName = '/PreStudentAddressInfo/';
    this.dataService.setMethodName = 'GetPreStudentAddressInfoList?StudentID='+ StudentID + ""; // setting method name from API controller.
    return this.dataService.getAll<preStudentAddressInfo[]>()
  } 
  public GetEducationalStream() {
    this.dataService.setControllerName = '/BasicEducationalStream/';
    this.dataService.setMethodName = 'GetBasicEducationalStreamList?EducationalStreamID=0'; // setting method name from API controller.
    return this.dataService.getAll<EducationalStream[]>()
  }
  public GetPreStudentOtherInfo(StudentID) {
    this.dataService.setControllerName = '/PreStudentOtherInfo/';
    this.dataService.setMethodName = 'GetPreStudentOtherInfoByStudentID?StudentID=' + StudentID + ''; // setting method name from API controller.
    return this.dataService.getAll<preStudentAddressInfo[]>()
  }
  public GetPreStudentOtherInfoWithCourseType(StudentID,CourseTypeID) {
    this.dataService.setControllerName = '/PreStudentOtherInfo/';
    this.dataService.setMethodName = 'GetPreStudentOtherInfoByStudentIDWithCourseType?StudentID=' + StudentID + '&CourseTypeID='+CourseTypeID +''; 
    return this.dataService.getAll<preStudentAddressInfo[]>()
  }
  public GetPreStudentOtherInfoForMarkUpdate(StudentID) {
    this.dataService.setControllerName = '/PreStudentOtherInfo/';
    this.dataService.setMethodName = 'GetPreStudentOtherInfoByStudentIDForMarkUpdate?StudentID=' + StudentID + ''; // setting method name from API controller.
    return this.dataService.getAll<preStudentAddressInfo[]>()
  }
  public GetBasicUniversityListByState(StateID) {
    this.dataService.setControllerName = '/BasicState/';
    this.dataService.setMethodName = 'GetBasicUniversityListByState?StateID=' + StateID + ''; // setting method name from API controller.
    return this.dataService.getAll<preStudentAddressInfo[]>()
  }
  public GetBasicUniversityListByStateForDiploma(StateID) {
    this.dataService.setControllerName = '/BasicState/';
    this.dataService.setMethodName = 'GetBasicUniversityListByStateForDiploma?StateID=' + StateID + ''; // setting method name from API controller.
    return this.dataService.getAll<preStudentAddressInfo[]>()
  }
  public GetEducationalBoardListByState(StateID) {
    this.dataService.setControllerName = '/BasicState/';
    this.dataService.setMethodName = 'GetEducationalBoardListByState?StateID=' + StateID + ''; // setting method name from API controller.
    return this.dataService.getAll<preStudentAddressInfo[]>()
  }

  addEducationalDetails(data: preStudentAddressInfo) {
    data.StudentOtherInfoID = educationaldetails.length + 1;
    educationaldetails.push(data);
  }
  saveEducationalDetails(data: preStudentAddressInfo) {

  }
  deleteEducationalDetails(data: preStudentAddressInfo) {
    
  }


  getUGmarkData() {
    return ugmarkdetails;
  } 
  getEducationData(){
    return educationdata;
  }
    
  

}
